import get from 'lodash.get';

const getPartnerLogoMobileWidth = (rootState) =>
  get(rootState, 'partner.properties.wsBranding.companyMobileLogoWidth');

export default getPartnerLogoMobileWidth;
